import React from "react";
import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import Switch from "@ui/Switch";
import t from "../../../i18n";

export const useDisplayInvalidPoints = createGlobalState({
  storage: "session",
  key: "displayInvalidPoints",
  type: io.boolean,
  scoped: true,
  defaultValue: false,
});

function ToggleDisplayInvalidPoints({ projectId }: { projectId: string }) {
  const [displayInvalidPoints, setDisplayInvalidPoints] = useDisplayInvalidPoints({
    scope: projectId,
  });

  return (
    <Switch
      checked={displayInvalidPoints}
      onChange={() => setDisplayInvalidPoints(state => !state)}
    >
      {t("project.analysis.toggle.display_invalid_points.text")}
    </Switch>
  );
}

export default React.memo(ToggleDisplayInvalidPoints);
